/* eslint-disable no-unused-vars */
/**

* © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile

* Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United

* States and/or other countries.

*/

import React from 'react';
import PropTypes from 'prop-types';

export default function DisplayErrorMessages (props) {
  return <div>{props.errorMessages.length > 0 ? <div className="alert alert-danger custom-alert" role="alert" >
    {props.errorMessages.map((message, index) => <li key ={index}>{message}</li>)
    }
  </div> : null
  }</div>;
}

DisplayErrorMessages.propTypes = {
  errorMessages: PropTypes.array.isRequired
};
